module.exports = __webpack_public_path__ + "static/media/close.01249c9c.svg";